// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"67713a38","114":"dc1f870c","257":"f9a86825","343":"2470b6d7","453":"258b012d","495":"ad5ec051","684":"8d8d4ed2","745":"9e7213f7"}[chunkId] + ".chunk.js";
};